
<template>
    <div class="workdetail">
        <div class="main_body">
            <div class="top_label">
                <span class="lable_name">{{task_name}}</span>
                <!-- <el-input v-model="keyword" style="width: 300px;" :clearable="true" @input="changKeyword" placeholder="请输入作业名称">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input> -->
                <el-button type="text" style="font-size: 16px;" @click="goBack"><i class="el-icon-arrow-left"></i> 返回</el-button>
            </div>
            <div class="work_statistics_box" style="margin-top:20px">
                <div class="work_statistics_title"> 
                    <i class="el-icon-stopwatch"></i>
                    <span>学习统计</span>
                </div>
                
                <div class="work_statistics">
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">今日做题</span>
                            <div class="statistics_item_left_num_box">
                                <span class="statistics_item_left_num">{{top_statistics.today_number}} 篇</span>
                                <span style="color: #F56C6C;" class="statistics_item_left_diff">正确率 {{top_statistics.today_average_score}}%</span>
                            </div>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon">
                                <i class="el-icon-time"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">分数</span>
                            <span class="statistics_item_left_num">{{top_statistics.total_fraction}} 分</span>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color: #FDE2E2;color: #F56C6C;">
                                <i class="el-icon-check"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">学习时长</span>
                            <span class="statistics_item_left_num">{{top_statistics.total_time}}</span>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color: #E1F3D8;color: #67C23A;">
                                <i class="el-icon-alarm-clock"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">阅读篇数</span>
                            <div class="statistics_item_left_num_box">
                                <span class="statistics_item_left_num">{{top_statistics.read_number}} 篇</span>
                                <span style="color: green;" class="statistics_item_left_diff">正确率 {{top_statistics.read_average_score}}%</span>
                            </div>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                <i class="el-icon-monitor"></i>
                            </span>
                        </div>
                    </div>
                    <div class="statistics_item">
                        <div class="statistics_item_left">
                            <span class="statistics_item_left_title">应试篇数</span>
                            <div class="statistics_item_left_num_box">
                                <span class="statistics_item_left_num">{{top_statistics.specatily_number}} 篇</span>
                                <span style="color: green;" class="statistics_item_left_diff">正确率 {{top_statistics.specatily_average_score}}%</span>
                            </div>
                        </div>
                        <div class="statistics_item_right">
                            <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                <i class="el-icon-edit"></i>
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="work_statistics_box">
                <div class="work_statistics_title"> 
                    <i class="el-icon-collection"></i>
                    <span>作业内容</span>
                </div>
                
                <Timeline v-if="worktype == 0" :periods_data="periods_data" :periods="periods" @selectPeriod="handleSelectPeriod"></Timeline>
            </div>

            <div class="work_detail_box">
                <div class="work_detail_list" @click="doWork(item)" v-for="(item, index) in work_list" :key="index"> 
                    <div class="work_detail_list_left">
                        <div class="work_detail_list_left_title">
                            <span class="work_detail_list_left_title_num">{{index + 1}}</span>
                            <span class="work_detail_list_left_title_text">{{item.title}}</span>
                        </div>
                        <span class="work_detail_list_left_type">{{item.type?'应试英语':'阅读在线'}}</span>
                    </div>
                    <span v-if="item.do" class="work_detail_list_left_status"><i class="el-icon-document-checked"></i> 已完成</span>
                    <span v-else style="background:#F56C6C" class="work_detail_list_left_status"><i class="el-icon-document-delete"></i> 未完成</span>
                    
                </div>
            </div>
        </div>
        <!--  -->
    </div>
</template>
<script>
import Http from "../../apis/student";
import Timeline from '../../../untils/timeline.vue'
export default {
    name: 'Workdetail',
    components: {
        Timeline
    },
    data(){
        return{
            task_id: this.$route.query.task_id,
            task_name: this.$route.query.task_name,
            worktype: this.$route.query.worktype,
            top_statistics: {},
            periods_data: [],
            periods: 0,
            work_list: []
        }
    },
    created(){
        this.workDetailTopStatistics()
        this.workDetailPeriods()
    },
    methods: {
        workDetailTopStatistics(){
            Http.workDetailTopStatistics({task_id: this.task_id}).then((res) => {
                this.top_statistics = res.data
            
            });
        },
        workDetailPeriods(){
            Http.workDetailPeriods({task_id: this.task_id}).then((res) => {
                this.periods_data = res.data.result
                this.periods = res.data.periods
                this.workDetailWorkList(res.data.periods)
            });
        },
        workDetailWorkList(periods){
            Http.workDetailWorkList({task_id: this.task_id,periods: periods}).then((res) => {
                this.work_list = res.data
            });
        },
        handleSelectPeriod(item){
            this.workDetailWorkList(item.periods)
        },
        doWork(item){

            if(item.type == 0){
                this.$router.push({name:'ReadDetail',query:{id:item.wid,task_id:this.task_id,plan_id:item.plan_id,periods:item.periods,worktype:this.worktype,type:0}})
            }else{
                this.$router.push({name:'SpecialtyDetail',query:{id:item.wid,task_id:this.task_id,plan_id:item.plan_id,periods:item.periods,worktype:this.worktype,type:item.z_type,dotype:0}})
            }
        },
        goBack(){
            this.$router.back(-1)
        }
    }
}
</script>
<style scoped>

.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
}
.work_statistics{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px;
    margin-top: 20px;
    
}

.statistics_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.statistics_item_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
}
.statistics_item_left_title{
    font-weight: 700;
}
.statistics_item_left_num{
    font-size: 14px;
    font-weight: 700;
}
.statistics_item_right_icon{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #D9ECFF;
    color: #409EFF;
}
.work_statistics_box{
    display: inline-block;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    
    margin-top: 25px;
}
.work_statistics_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-size: 18px;
}
.work_statistics_title span{
    font-weight: 700;
}
.work_statistics_title i{
    
    color: #409EFF;
}
.statistics_item_left_num_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
}
.statistics_item_left_diff{
    font-size: 12px;
}
.work_detail_box{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: stretch;
    grid-gap: 20px;
    padding: 20px;
    box-sizing: border-box;
}
.work_detail_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    cursor: pointer;
}
.work_detail_list_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    text-align: left;
    flex: 1;
    min-width: 0;
}
.work_detail_list_left_title_num{
    font-size: 14px;
    font-weight: 700;
    background: #409EFF;
    color: #fff;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    flex-shrink: 0;
}
.work_detail_list_left_title{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    align-items: center;
    min-width: 0;
}

.work_detail_list_left_status{
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 12px;
    background: #409EFF;
    color: #fff;
    white-space: nowrap;
    flex-shrink: 0;
}
.work_detail_list_left_type{
    font-size: 14px;
    opacity: 0.6;
}
.work_detail_list_left_title_text{
    font-size:15px;
}
</style>
